import kea = require('node_modules/kea-react/dist/index');
import models = require("app/models/requireme");
import { rpcController } from "../rpc";
import { cacheResource } from 'kea-resource';

const controller = rpcController("Logistica");


export const Logistica = cacheResource({
    /**
 * Establece una guia en cierta sucursal, sobreescribiendo cualquier otro status anterior de la guia
 */
    GuiaEnSucursal: async (folio: string, idSucursal: number): Promise<void> => await controller("GuiaEnSucursal", { folio, idSucursal }),
    /**Obtiene las rutas posibles entre dos sucursales */
    Enrutar: async (idSucursalOrigen: number, idSucursalDestino: number, idRutaOrigen?: number | null): Promise<models.SolucionEnrutamiento[]> => await controller('Enrutar', { idSucursalOrigen, idSucursalDestino, idRutaOrigen }),
})


// WEBPACK FOOTER //
// ./app/resources/items/logistica.tsx